import { AuthFlowError, Locales } from '@griply/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { completeSignupAndLogin } from 'shared/services/backend-api';
import { User } from 'shared/types/user';

import { queryKey as useUserKey } from './use-user-query';

export const useCompleteSignupAndLoginMutation = () => {
  const client = useQueryClient();

  return useMutation<
    User | null,
    AuthFlowError,
    {
      password: string;
      claimToken: string;
      name?: string;
      locale?: Locales;
    }
  >({
    mutationFn: async ({ password, claimToken, name, locale }) => {
      const user = await completeSignupAndLogin(claimToken, password, {
        name,
        locale,
      });

      await client.invalidateQueries({ queryKey: [useUserKey] });

      return user;
    },
  });
};
